import { render, staticRenderFns } from "./PatientGiftCard.vue?vue&type=template&id=4b2facf4&scoped=true"
import script from "./PatientGiftCard.vue?vue&type=script&lang=js"
export * from "./PatientGiftCard.vue?vue&type=script&lang=js"
import style0 from "./PatientGiftCard.scss?vue&type=style&index=0&id=4b2facf4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2facf4",
  null
  
)

export default component.exports